import gql from "graphql-tag";

export const SIGN_IN = gql`
    mutation LoginUser($userName: String!, $password: String!, $lat: Number, $long: Number) {
        loginUser(userName: $userName, password: $password, lat: $lat, long: $long) {
            token
            data {
                EMP_CODE
                EMP_SITE
                EMP_TYPE
                EMP_FNAME
                EMP_LNAME
                SHORT_NAME
                DESIGNATION
                DEPT_CODE
                EMAIL_ID_OFF
                MOBILE_NO_OFF
                PASS_WD
                PASSWD_FREQ
                PROFILE_ID
                ACTIVE
            }
        }
    }
`;
